/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Feedback_Thumbs_Up_TooltipInputs */



/**
* | output |
* | --- |
* | "Helpful response" |
*
* @param {Chat_Feedback_Thumbs_Up_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_feedback_thumbs_up_tooltip = /** @type {((inputs?: Chat_Feedback_Thumbs_Up_TooltipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Feedback_Thumbs_Up_TooltipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Hilfreiche Antwort")
	return /** @type {LocalizedString} */ ("Helpful response")
});